import { createStore } from '@'

export const $projects = createStore('alert-setting:projects')
export const $accounts = createStore('alert-setting:accounts')
export const $alertSettings = createStore('alert-setting:alertSettings')
